// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.myCompanyMain {
  padding-top: 20px;
}
.myCompanyMain .color-grey {
  color: #4e5857 !important;
}
.myCompanyMain .background-comany {
  background-image: url("https://assets.mydna.company/Wireframe Empresa_Desktop.png") !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  margin-top: -90px !important;
  margin-bottom: -100px;
  margin-left: -10px;
  width: 100vw !important;
  height: 880px !important;
  overflow: hidden;
  position: relative;
}
.myCompanyMain .wheel-paquetes {
  position: absolute;
  top: 100px;
  right: 10px;
  border: none;
  border-radius: 50rem;
  background: rgb(123, 107, 228);
  padding: 5px 20px;
  color: white;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
}
.myCompanyMain .wheel-paquetes:hover {
  background: rgb(147, 134, 233);
  color: white;
}
.myCompanyMain .btn-internal-comunication {
  border: 2px solid #7A6BE8;
  background-color: #7A6BE8;
  color: white;
  text-align: center;
  padding-right: 30px;
  padding-left: 30px;
  border-radius: 20px;
  font-size: 18px;
}
.myCompanyMain .btn-internal-comunication:hover {
  border: 2px solid #7A6BE8 !important;
  background-color: white;
  color: #3e3e3e;
}
.myCompanyMain .btn-canal-denuncia {
  border: 2px solid #7A6BE8;
  color: #7A6BE8;
  text-align: center;
  padding-right: 30px;
  padding-left: 30px;
  border-radius: 20px;
  font-size: 18px;
}
.myCompanyMain .btn-canal-denuncia:hover {
  border: 2px solid #7A6BE8;
  background-color: #7A6BE8;
  color: white;
}
.myCompanyMain .btn-internal-vancancies {
  border: 2px solid #2cd8de;
  background-color: #2cded3;
  color: white;
  text-align: center;
  padding-right: 30px;
  padding-left: 30px;
  border-radius: 20px;
  font-size: 18px;
}
.myCompanyMain .btn-internal-vancancies:hover {
  border: 2px solid #2cded3 !important;
  background-color: white;
  color: #3e3e3e;
}
.myCompanyMain .wheelCompanyPage-last-row-adjust {
  margin-top: -110px;
}
.myCompanyMain .wheelCompanyPage-list img {
  width: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Views/MyCompany/myCompany.sass"],"names":[],"mappings":"AAAA;EACC,iBAAA;AACD;AAAC;EACC,yBAAA;AAEF;AADC;EACC,8FAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,4BAAA;EACA,qBAAA;EACA,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,gBAAA;EACA,kBAAA;AAGF;AADC;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,8BAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAGF;AADE;EACC,8BAAA;EACA,YAAA;AAGH;AADC;EACC,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAGF;AAFE;EACC,oCAAA;EACA,uBAAA;EACA,cAAA;AAIH;AAFC;EACC,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAIF;AAFE;EACC,yBAAA;EACA,yBAAA;EACA,YAAA;AAIH;AAFC;EACC,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAIF;AAHE;EACC,oCAAA;EACA,uBAAA;EACA,cAAA;AAKH;AAHC;EACC,kBAAA;AAKF;AAFE;EACC,WAAA;AAIH","sourcesContent":[".myCompanyMain\r\n\tpadding-top: 20px\r\n\t& .color-grey\r\n\t\tcolor: #4e5857 !important\r\n\t& .background-comany\r\n\t\tbackground-image: url(\"https://assets.mydna.company/Wireframe Empresa_Desktop.png\") !important\r\n\t\tbackground-size: cover\r\n\t\tbackground-repeat: no-repeat\r\n\t\tbackground-position: center\r\n\t\tmargin-top: -90px !important\r\n\t\tmargin-bottom: -100px\r\n\t\tmargin-left: -10px\r\n\t\twidth: 100vw !important\r\n\t\theight: 880px !important\r\n\t\toverflow: hidden\r\n\t\tposition: relative\r\n\r\n\t.wheel-paquetes\r\n\t\tposition: absolute\r\n\t\ttop: 100px\r\n\t\tright: 10px\r\n\t\tborder: none\r\n\t\tborder-radius: 50rem\r\n\t\tbackground: rgb(123, 107, 228)\r\n\t\tpadding: 5px 20px\r\n\t\tcolor: white\r\n\t\tfont-size: 18px\r\n\t\tfont-weight: 500\r\n\t\tcursor: pointer\r\n\r\n\t\t&:hover\r\n\t\t\tbackground: rgb(147, 134, 233)\r\n\t\t\tcolor: white\r\n\r\n\t.btn-internal-comunication\r\n\t\tborder: 2px solid #7A6BE8\r\n\t\tbackground-color: #7A6BE8\r\n\t\tcolor: white\r\n\t\ttext-align: center\r\n\t\tpadding-right: 30px\r\n\t\tpadding-left: 30px\r\n\t\tborder-radius: 20px\r\n\t\tfont-size: 18px\r\n\t\t&:hover\r\n\t\t\tborder: 2px solid #7A6BE8 !important\r\n\t\t\tbackground-color: white\r\n\t\t\tcolor: #3e3e3e\r\n\r\n\t.btn-canal-denuncia\r\n\t\tborder: 2px solid #7A6BE8\r\n\t\tcolor: #7A6BE8\r\n\t\ttext-align: center\r\n\t\tpadding-right: 30px\r\n\t\tpadding-left: 30px\r\n\t\tborder-radius: 20px\r\n\t\tfont-size: 18px\r\n\r\n\t\t&:hover\r\n\t\t\tborder: 2px solid #7A6BE8\r\n\t\t\tbackground-color: #7A6BE8\r\n\t\t\tcolor: white\r\n\r\n\t.btn-internal-vancancies\r\n\t\tborder: 2px solid #2cd8de\r\n\t\tbackground-color: #2cded3\r\n\t\tcolor: white\r\n\t\ttext-align: center\r\n\t\tpadding-right: 30px\r\n\t\tpadding-left: 30px\r\n\t\tborder-radius: 20px\r\n\t\tfont-size: 18px\r\n\t\t&:hover\r\n\t\t\tborder: 2px solid #2cded3 !important\r\n\t\t\tbackground-color: white\r\n\t\t\tcolor: #3e3e3e\r\n\r\n\t& .wheelCompanyPage-last-row-adjust\r\n\t\tmargin-top: -110px\r\n\r\n\t& .wheelCompanyPage-list\r\n\t\t& img\r\n\t\t\twidth: 20px\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
